// extracted by css-extract-rspack-plugin
export default {"success":"StatusesColor_success__9RIb5","alert":"StatusesColor_alert__1wyfs","error":"StatusesColor_error__qXNtO","default":"StatusesColor_default__9nbxx"};